import { NegotiationState } from '../types/negotiationWebsocket'

export const initialNegotiationState: NegotiationState = {
  isConnected: false,
  error: null,
  negotiations: [],
  messages: [],
  isLoading: false,
  pagination: null,
  loadingMoreMessages: false,
  unreadByNegotiationId: {},
  replyTargets: {},
}
